import React from 'react';
import PropTypes from 'prop-types';
import _reduce from 'lodash/reduce';
import { ReactComponent as LogoOmni } from 'assets/svg/logos/logo-omni.svg';
import { ReactComponent as LogoLogin } from 'assets/svg/logos/logo-login.svg';
import { ReactComponent as LogoIpsum } from 'assets/svg/logos/logoipsum.svg';
import { isFeatureEnabled } from 'app/featureFlags';
import { FEATURE_FLAGS } from 'app/featureFlags/constants';

const LOGOS = {
  v1: LogoOmni,
  v2: LogoLogin,
};

const appLogoVersions = _reduce(LOGOS, (result, item, key) => ({
  [key]: key,
}), {});

const AppLogo = ({ color, version, link }) => {
  const Logo = LOGOS[version] || LOGOS.v1;
  return (
    <>
      {isFeatureEnabled(FEATURE_FLAGS.APP_BRANDING)
        ? (<Logo
            {...(
              link ? {
                onClick: () => window.open(link, '_blank'),
                style: { cursor: 'pointer' }
              } : {}
            )}
          />)
        : (<LogoIpsum fill={color} viewBox="25 25 130 50" />)}
    </>
  );
};

AppLogo.propTypes = {
  color: PropTypes.string,
  version: PropTypes.oneOf(Object.values(appLogoVersions)),
  link: PropTypes.string
};

AppLogo.defaultProps = {
  color: '#ffffff',
  version: appLogoVersions.v1,
  link: null
};

export default AppLogo;

export { appLogoVersions };